// KPI
export const SET_GENERAL_DETAILS = "SET_GENERAL_DETAILS";
